// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"b890b78c","513":"b4138734","787":"0141d658"}[chunkId] + ".chunk.js";
};